import { Link } from 'react-router-dom';

const SERVICES = [
  {
    icon: 'ri-home-gear-fill',
    title: 'Roof Replacement',
    subtitle: 'Residential',
    desc: 'Full tear-off and premium replacement with materials designed for Utah\'s climate — heavy snow, summer UV, spring hail.',
    href: '/services/roof-replacement',
    image: 'https://public.readdy.ai/ai/img_res/fb172a4ab32b1a69aace1b20f29cf67d.jpg',
    tag: 'Most Popular',
  },
  {
    icon: 'ri-tools-fill',
    title: 'Roof Repair',
    subtitle: 'Emergency & Routine',
    desc: 'Fast, lasting repairs for leaks, missing shingles, damaged flashing, and storm impact — before small issues become expensive problems.',
    href: '/services/roof-repair',
    image: 'https://readdy.ai/api/search-image?query=professional%20roofer%20doing%20precision%20repair%20work%20on%20asphalt%20shingle%20roof%20Utah%20home%2C%20replacing%20damaged%20shingles%20with%20expert%20care%2C%20safety%20equipment%20visible%2C%20clear%20blue%20sky&width=700&height=480&seq=svc-repair-v2&orientation=landscape',
    tag: 'Fast Response',
  },
  {
    icon: 'ri-building-4-fill',
    title: 'Commercial Roofing',
    subtitle: 'All Building Types',
    desc: 'TPO, EPDM, and metal systems for Utah warehouses, office buildings, and commercial complexes — on time, on budget, code-compliant.',
    href: '/services/commercial',
    image: 'https://readdy.ai/api/search-image?query=aerial%20view%20of%20large%20commercial%20warehouse%20with%20professional%20white%20TPO%20flat%20roof%20being%20installed%20by%20crew%20Utah%2C%20industrial%20roofing%20project%2C%20clean%20professional%20work%2C%20mountains%20visible%20in%20distance&width=700&height=480&seq=svc-commercial-v2&orientation=landscape',
    tag: 'Commercial Grade',
  },
  {
    icon: 'ri-cloud-windy-fill',
    title: 'Storm Damage',
    subtitle: 'Hail & Wind',
    desc: 'Emergency response for hail and wind-damaged roofs across Utah. Full documentation and expert insurance claim advocacy.',
    href: '/services/storm-damage',
    image: 'https://readdy.ai/api/search-image?query=roofing%20contractor%20assessing%20hail%20storm%20damage%20on%20residential%20roof%20Utah%2C%20close%20up%20of%20damaged%20shingles%20showing%20impact%20marks%2C%20professional%20inspection%20in%20progress%2C%20overcast%20dramatic%20sky&width=700&height=480&seq=svc-storm-v2&orientation=landscape',
    tag: 'Emergency Ready',
  },
  {
    icon: 'ri-file-paper-2-fill',
    title: 'Insurance Claims',
    subtitle: 'Full Claim Support',
    desc: 'We handle every step of your insurance claim — from documentation through adjuster meetings — to maximize your payout.',
    href: '/services/storm-damage',
    image: 'https://readdy.ai/api/search-image?query=roofing%20professional%20and%20homeowner%20reviewing%20insurance%20claim%20documents%20together%20outside%20home%20Utah%2C%20friendly%20professional%20consultation%2C%20trusting%20interaction%2C%20home%20roof%20visible%20in%20background&width=700&height=480&seq=svc-insurance-v2&orientation=landscape',
    tag: 'Claim Specialists',
  },
  {
    icon: 'ri-search-eye-fill',
    title: 'Roof Inspections',
    subtitle: 'Free Assessments',
    desc: 'Comprehensive roof inspections for home buyers, sellers, and proactive maintenance — with detailed written reports.',
    href: '/services/roof-repair',
    image: 'https://readdy.ai/api/search-image?query=certified%20roof%20inspector%20carefully%20examining%20residential%20shingle%20roof%20Utah%20suburban%20home%2C%20using%20inspection%20tools%20and%20clipboard%2C%20safety%20harness%2C%20clear%20mountain%20sky%20background&width=700&height=480&seq=svc-inspect-v2&orientation=landscape',
    tag: 'Free Inspection',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block w-16 h-1 bg-brand-orange rounded-full mb-6"></div>
          <h2 className="font-heading font-900 text-charcoal text-5xl md:text-6xl lg:text-7xl uppercase tracking-tight leading-none mb-4">
            Roofing Services Built for<br />
            <span className="text-brand-orange">Utah Homes &amp; Businesses</span>
          </h2>
          <p className="font-body text-charcoal/60 text-lg max-w-2xl mx-auto">
            From emergency repairs to full commercial installations — certified crews, premium materials, and workmanship that lasts.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => (
            <div
              key={s.title}
              className="group bg-white border border-surface-dark rounded-2xl overflow-hidden hover:border-brand-orange/30 transition-all duration-300"
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/60 to-transparent"></div>
                <div className="absolute top-4 right-4">
                  <span className="bg-brand-orange text-white font-heading font-700 text-xs uppercase tracking-widest px-3 py-1 rounded-full">
                    {s.tag}
                  </span>
                </div>
                <div className="absolute bottom-4 left-4 w-10 h-10 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-lg">
                  <i className={`${s.icon} text-white text-xl`}></i>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <p className="font-body text-brand-orange text-xs font-700 uppercase tracking-widest mb-1">{s.subtitle}</p>
                <h3 className="font-heading font-900 text-charcoal text-2xl uppercase tracking-wide mb-2">{s.title}</h3>
                <p className="font-body text-charcoal/60 text-sm leading-relaxed mb-4">{s.desc}</p>
                <Link
                  to={s.href}
                  className="inline-flex items-center gap-2 text-brand-orange font-body text-sm font-700 group-hover:gap-3 transition-all duration-200 cursor-pointer"
                >
                  Learn More
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
